import { LabelsDefaultLabelFormatFormValues } from '~/pages/Settings/Labels/LabelsDefaultForm';
import { ILabelsSettingValues } from '~/pages/Settings/Labels/types';
import LabelFormat from '~/types/LabelFormat';
import PackingSlipFormat from '~/types/PackingSlipFormat';

type JSONLabelSetting = {
  default_label_format: string;
  default_packing_slip_format: number;
  is_merged_labels_packing_slips: boolean;
  default_shipment_reference_1: string;
  default_shipment_reference_2: string;
  default_provider: string;
  default_outbound_service_level: string;
  is_signature_confirmation_selected: boolean;
  default_return_service_level: string;
  is_auto_create_return_label: boolean;
  is_use_order_number: boolean;
  label_logo_type: string;
  store_policy_text: string;
  packing_slip_text: string;
  is_packing_slip_hide_prices: boolean;
};

type LabelSettings = {
  defaultLabelFormat: LabelFormat;
  defaultPackingSlipFormat: PackingSlipFormat;
  isMergeLabelsAndPackingSlips: boolean;
  isUseOrderNumber: boolean;
  refText1: string;
  refText2: string;
  outboundServiceLevel: string;
  isRequireSignatureConfirmation: boolean;
  outboundReturnLabelServiceLevel: string;
  outboundCarrierServiceLevelAccount: string;
  isAutoCreateReturnLabels: boolean;
  labelLogoType: string;
};

// TODO: ENG-27631 - Rename to toJSON after Old Label Setting page is retired.
function toJSONv2(labelSettings: ILabelsSettingValues) {
  return {
    default_label_format: labelSettings.defaultLabelFormat || null,
    default_packing_slip_format: labelSettings.defaultPackingSlipFormat || null,
    is_merged_labels_packing_slips: labelSettings.isMergeLabelsAndPackingSlips, // TODO: is this needed
    default_shipment_reference_1: labelSettings.refText1 || '',
    default_shipment_reference_2: labelSettings.refText2 || '',
    default_outbound_account: labelSettings.outboundServiceLevel
      ? labelSettings.outboundCarrierServiceLevelAccount?.toString()
      : null,
    default_provider: labelSettings.outboundCarrierServiceLevel?.toString() || null,
    default_outbound_service_level: labelSettings.outboundServiceLevel?.toString() || null,
    default_return_account: labelSettings.returnLabelServiceLevel
      ? labelSettings.returnLabelCarrierAccount?.toString()
      : null,
    default_return_provider: labelSettings.returnLabelCarrier?.toString() || null,
    default_return_service_level: labelSettings.returnLabelServiceLevel?.toString() || null,
    is_signature_confirmation_selected: labelSettings.isRequireSignatureConfirmation || false,
    is_auto_create_return_label: labelSettings.isAutoCreateReturnLabels,
    is_use_order_number: labelSettings.isUseOrderNumber,
    label_logo_type: labelSettings.labelLogoType || null, // TODO: is this needed
    store_policy_text: labelSettings.storePolicyText || '',
    packing_slip_text: labelSettings.packingSlipText || '', // TODO: is this needed
    is_packing_slip_hide_prices: !labelSettings.packingSlipShowPrices || false,
  };
}

// TODO: ENG-27631 - Remove after Old Label Setting page is retired.
function toJSON(labelSettings: LabelsDefaultLabelFormatFormValues) {
  return {
    default_label_format: labelSettings.defaultLabelFormat
      ? labelSettings.defaultLabelFormat.value
      : null,
    default_packing_slip_format: labelSettings.defaultPackingSlipFormat
      ? labelSettings.defaultPackingSlipFormat.value
      : null,
    is_merged_labels_packing_slips: labelSettings.isMergeLabelsAndPackingSlips,
    default_shipment_reference_1: labelSettings.refText1,
    default_shipment_reference_2: labelSettings.refText2,
    default_outbound_account: labelSettings.outboundServiceLevel?.value
      ? labelSettings.outboundCarrierServiceLevelAccount?.value.toString()
      : null,
    default_provider: labelSettings.outboundCarrierServiceLevel
      ? labelSettings.outboundCarrierServiceLevel.value.toString()
      : null,
    default_outbound_service_level: labelSettings.outboundServiceLevel?.value.toString(),
    default_return_account: labelSettings.returnLabelServiceLevel?.value
      ? labelSettings.returnLabelCarrierAccount?.value.toString()
      : null,
    default_return_provider: labelSettings.returnLabelCarrier
      ? labelSettings.returnLabelCarrier?.value.toString()
      : null,
    default_return_service_level: labelSettings.returnLabelServiceLevel
      ? labelSettings.returnLabelServiceLevel?.value.toString()
      : null,
    is_signature_confirmation_selected: labelSettings.isRequireSignatureConfirmation,
    is_auto_create_return_label: labelSettings.isAutoCreateReturnLabels,
    is_use_order_number: labelSettings.isUseOrderNumber,
    label_logo_type: labelSettings.labelLogoType ? labelSettings.labelLogoType.value : null,
    store_policy_text: labelSettings.storePolicyText || '',
    packing_slip_text: labelSettings.packingSlipText || '',
    is_packing_slip_hide_prices: !labelSettings.packingSlipShowPrices || false,
  };
}

function fromJSON(data: JSONLabelSetting) {
  return {
    defaultLabelFormat: data.default_label_format,
    defaultPackingSlipFormat: data.default_packing_slip_format,
    isMergeLabelsAndPackingSlips: data.is_merged_labels_packing_slips,
    refText1: data.default_shipment_reference_1,
    refText2: data.default_shipment_reference_2,
    outboundServiceLevel: data.default_outbound_service_level,
    isRequireSignatureConfirmation: data.is_signature_confirmation_selected,
    outboundReturnLabelServiceLevel: data.default_return_service_level,
    isAutoCreateReturnLabels: data.is_auto_create_return_label,
    isUseOrderNumber: data.is_use_order_number,
    labelLogoType: data.label_logo_type,
    storePolicyText: data.store_policy_text,
    packingSlipText: data.packing_slip_text,
    packingSlipShowPrices: !data.is_packing_slip_hide_prices,
  };
}

export { JSONLabelSetting, LabelSettings };
export { fromJSON as labelSettingsFromJSON };
export { toJSON as labelSettingsToJSON };
export { toJSONv2 as labelSettingsToJSONv2 };
